var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _templateObject = _taggedTemplateLiteralLoose(["\n  display: flex;\n  align-items: center;\n  font-size: 1.2rem;\n  height: 2rem;\n  border-radius: 0;\n  border-bottom: 1px dashed;\n  & .cm-content {\n    padding: 0 !important;\n  }\n  & .cm-scroller {\n    overflow-x: hidden !important;\n    line-height: 1.2 !important;\n  }\n"], ["\n  display: flex;\n  align-items: center;\n  font-size: 1.2rem;\n  height: 2rem;\n  border-radius: 0;\n  border-bottom: 1px dashed;\n  & .cm-content {\n    padding: 0 !important;\n  }\n  & .cm-scroller {\n    overflow-x: hidden !important;\n    line-height: 1.2 !important;\n  }\n"]);

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }

/** @jsx jsx */
import React, { Fragment, useState, forwardRef } from "react";
import { capitalize, isNil } from "lodash-es";
import { observer } from "mobx-react";
import { jsx, css } from "@emotion/core";
import { Stack, FormControl, FormLabel, Input, ButtonGroup, Button, Select, NumberInput, NumberInputField } from "@chakra-ui/core";
import { findFormatterByProp } from "./common";
import { FIELD_TYPES, formatters } from "../../core/common";
import FormulaInput from "../FormulaInput";

var formulaInputWrapperStyles = css(_templateObject);

var FormField = forwardRef(function (_ref, ref) {
  var _ref$as = _ref.as,
      Component = _ref$as === undefined ? Input : _ref$as,
      id = _ref.id,
      label = _ref.label,
      _ref$size = _ref.size,
      size = _ref$size === undefined ? "sm" : _ref$size,
      formControlProps = _ref.formControlProps,
      props = _objectWithoutProperties(_ref, ["as", "id", "label", "size", "formControlProps"]);

  return jsx(
    FormControl,
    formControlProps,
    jsx(
      FormLabel,
      { htmlFor: id, fontSize: size },
      label
    ),
    jsx(Component, _extends({ ref: ref, id: id, size: size, variant: "flushed" }, props))
  );
});

var fieldTypesArray = Object.values(FIELD_TYPES);

function FieldForm(_ref2) {
  var node = _ref2.node;

  var _useState = useState(node.name),
      name = _useState[0],
      setName = _useState[1];

  var _useState2 = useState(node.fieldType),
      fieldType = _useState2[0],
      setFieldType = _useState2[1];

  var _useState3 = useState(node.fieldMetaData),
      fieldMetaData = _useState3[0],
      setFieldMetaData = _useState3[1];

  var _useState4 = useState(findFormatterByProp("formatter", node.formatter, "key")),
      formatter = _useState4[0],
      setFormatter = _useState4[1];

  var _useState5 = useState(isNil(node.value) ? "" : node.value),
      value = _useState5[0],
      setValue = _useState5[1];

  var onFieldTypeChange = function onFieldTypeChange(fieldType) {
    setFieldType(fieldType);
    if (fieldType === FIELD_TYPES.slider) {
      setValue("25");
      setFieldMetaData({
        min: 0,
        max: 50,
        step: 1
      });
      return;
    }

    if (fieldType === FIELD_TYPES.plain) {
      setValue("");
      setFieldMetaData(null);
    }
  };

  var onFieldMetaDataChange = function onFieldMetaDataChange(key, value) {
    var _extends2;

    setFieldMetaData(_extends({}, fieldMetaData, (_extends2 = {}, _extends2[key] = value, _extends2)));
  };

  var onFormulaInputChange = function onFormulaInputChange(value) {
    setValue(value);
  };

  var handleSave = function handleSave() {
    node.handleSave(value, name, findFormatterByProp("key", formatter, "formatter"), fieldType, fieldMetaData);
  };

  return jsx(
    Stack,
    null,
    jsx(FormField, {
      label: "name",
      id: "name",
      value: name,
      onChange: function onChange(_ref3) {
        var target = _ref3.target;
        return setName(target.value);
      }
    }),
    jsx(
      FormField,
      {
        as: Select,
        label: "field type",
        id: "type",
        value: fieldType,
        onChange: function onChange(_ref4) {
          var target = _ref4.target;
          return onFieldTypeChange(target.value);
        }
      },
      fieldTypesArray.map(function (value) {
        return jsx(
          "option",
          {
            key: value,
            value: value,
            disabled: ["merge", "date", "select"].some(function (x) {
              return x === value;
            })
          },
          capitalize(value)
        );
      })
    ),
    jsx(
      FormField,
      {
        as: Select,
        label: "format",
        id: "format",
        value: findFormatterByProp("formatter", formatter, "key"),
        onChange: function onChange(_ref5) {
          var target = _ref5.target;
          return setFormatter(target.value);
        }
      },
      formatters.map(function (_ref6) {
        var key = _ref6.key,
            text = _ref6.text;
        return jsx(
          "option",
          { key: key, value: key },
          text
        );
      })
    ),
    jsx(
      FormControl,
      null,
      jsx(
        FormLabel,
        { fontSize: "sm" },
        "value"
      ),
      fieldType === FIELD_TYPES.plain ? jsx(FormulaInput, {
        id: node.id,
        css: formulaInputWrapperStyles,
        value: node.value,
        store: node.store
        // onSave={handleSave}
        , onChange: onFormulaInputChange
      }) : fieldType === FIELD_TYPES.slider ? jsx(
        Fragment,
        null,
        jsx(
          NumberInput,
          { value: value, onChange: setValue },
          jsx(NumberInputField, null)
        ),
        jsx(
          Stack,
          { isInline: true, spacing: 1, mt: 1 },
          [{ key: "min", value: 0 }, { key: "max", value: 50 }, { key: "step", value: 1 }].map(function (f, i) {
            return jsx(
              FormControl,
              { key: i },
              jsx(
                FormLabel,
                { fontSize: "xs", pb: 0 },
                f.key
              ),
              jsx(
                NumberInput,
                {
                  size: "sm",
                  value: fieldMetaData[f.key],
                  onChange: function onChange(value) {
                    onFieldMetaDataChange(f.key, value);
                  }
                },
                jsx(NumberInputField, null)
              )
            );
          })
        )
      ) : jsx(
        "div",
        null,
        fieldType
      )
    ),
    jsx(
      ButtonGroup,
      { d: "flex", justifyContent: "flex-end", mt: 2 },
      jsx(
        Button,
        { size: "sm", onClick: handleSave },
        "Save"
      )
    )
  );
}

export default observer(FieldForm);